import React from "react";
import Hero from "../../components/homeSessions/hero/Hero";
import CardTop from "../../components/homeSessions/cardTop/CardTop";
import BlockSession from "../../components/homeSessions/blockSession/BlockSession";
import MiddleCard from "../../components/homeSessions/middleCard/MiddleCard";
import ScheduleSession from "../../components/homeSessions/scheduleSession/ScheduleSession";
import CardBottom from "../../components/homeSessions/cardBottom/CardBottom";
import VideoSession from "../../components/homeSessions/videoSession/VideoSession";
import GoogleReviewsSection from "../../components/googleReviews/GoogleReviewsSection";
export default function HomeScreen() {
  return (
    <div>
      <Hero />
      <CardTop />
      <BlockSession />
      <MiddleCard />
      <ScheduleSession />
      <GoogleReviewsSection />
      <VideoSession />
      <CardBottom />
    </div>
  );
}
